<template>
    <div class="layout12-media-content">
        <div class="media-info">
            <div
                v-if="type === 'text' && !!title"
                class="title-text"
            >
                <site-title
                    :title="title"
                    :size="titleSize"
                    :mbSize="titleMbSize"
                    :align="align"
                    role="heading"
                    :aria-level="1"
                />
                <div
                    v-show="showShadow"
                    class="media-shadow"
                    :style="shadowStyle"
                ></div>
            </div>
            <div
                v-if="type === 'image' && !!titlePic"
                class="title-image"
            >
                <site-img
                    :src="titlePic.imgUrl || titlePic"
                    :alt="titlePic.alt || ''"
                    dir="height"
                    :style="{ height: logoHeight }"
                    :size="size"
                    ref="layout12Logo"
                />
            </div>
            <div
                v-if="subTitle"
                class="title-text"
            >
                <site-sub-title
                    :title="subTitle"
                    :size="subTitleSize"
                    :mbSize="subTitleMbSize"
                    :align="align"
                    role="heading"
                    :aria-level="3"
                />
            </div>
            <slot name="info"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        },
        align: {
            type: String,
            default: 'center'
        },
        title: {
            type: String,
            default: ''
        },
        titleSize: {
            type: Number,
            default: 70
        },
        titleMbSize: {
            type: Number,
            default: 35
        },
        subTitle: {
            type: String,
            default: ''
        },
        subTitleSize: {
            type: Number,
            default: 20
        },
        subTitleMbSize: {
            type: Number,
            default: 18
        },
        titlePic: {
            validator: function(value) {
                return (
                    typeof value === 'string' ||
                    typeof value === 'object' ||
                    !value
                );
            },
            default: ''
        },
        size: {
            type: Number,
            default: 100
        },
        titlePic2: {
            validator: function(value) {
                return (
                    typeof value === 'string' ||
                    typeof value === 'object' ||
                    !value
                );
            },
            default: ''
        },
        titlePic3: {
            validator: function(value) {
                return (
                    typeof value === 'string' ||
                    typeof value === 'object' ||
                    !value
                );
            },
            default: ''
        },
        showShadow: {
            type: Boolean,
            default: false
        },
        shadowStyle: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            layout15LogoListLen: 0,
        }
    },
    computed: {
        isMobile() {
            return this.platform.isMobile;
        },
        maxSize() {
            if (this.isMobile) {
                return 141;
            } else {
                return 164;
            }
        },
        logoHeight() {
            if (!this.isMobile) {
                return `${this.size / 100}em`;
            }
            return `${Math.min(this.size, this.maxSize) / 100}em`; 
        }
    },
    watch: {
        size: {
            immediate: true,
            handler(newValue, oldValue) {
                this.$nextTick(() => {
                    this.updateHeight(newValue, oldValue);
                });
            },
        },
    },
    methods: {
        // 判断是否需要锁定 `maxSize`
        shouldLockSize(imgWidth, containerWidth, size, oldSize) {
            if (imgWidth >= containerWidth - 10) {
                if (this.maxSizeLocked) {
                    return;
                }
                this.maxSize = oldSize;
                this.maxSizeLocked = true;
                this.logoHeight = `${this.maxSize / 100}em`;
            } else {
                this.maxSizeLocked = false;
                this.logoHeight = `${size / 100}em`;
            }
        },
        updateHeight(size, oldSize) {
            if (this.isMobile) {
                const layoutLogo = this.$el.querySelector('.title-image img');
                if (layoutLogo && layoutLogo.parentElement) {
                    let imgWidth =  layoutLogo.offsetWidth;
                    let containerWidth = layoutLogo.parentElement.offsetWidth;
                    this.shouldLockSize(imgWidth, containerWidth, size, oldSize);
                }
            } else {
                this.logoHeight = `${size / 100}em`;
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.layout12-media-content {
    position: relative;
    z-index: var(--level-sublow);
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-text {
        position: relative;
        .media-shadow {
            position: absolute;
            left: 50%;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            background-color: #000000;
            opacity: 0.6;
            transform: translateX(-50%);
            white-space: nowrap;
        }
        .site-subtitle{
            margin-top: 20px;
            @include media-600 {
                margin-top: 15px;
            }
        }
    }
    .title-image {
        text-align: center;
        margin-bottom: 40px;
        width: 100%;
        overflow: hidden;
        img {
            max-width: 100%;
            font-size: 100px;
        }
    }
}
</style>
